// Import dependencies
import { initialiser } from '@ramenjs/utilitybelt';

class Modal {
  constructor(config) {
    const { el, settings } = config;
    const modalId = el.getAttribute(settings.modalIdAttr);

    // Set module dom elements
    this.button = el;
    this.modal = document.getElementById(modalId);
    this.closeButton = this.modal?.querySelector(settings.closeButton);
    this.modalInner = this.modal?.querySelector(settings.modalInner);

    if (this.modalInner.querySelector('.js-video')) {
      this.videoComponent = this.modalInner.querySelector('.js-video');
      this.iframe = this.modalInner.querySelector('iframe');
    } else {
      this.iframe = null;
      this.videoComponent = null;
    }

    // Set settings
    this.settings = settings;
  }

  // Initialisation Function
  init = () => {
    this.button.addEventListener('click', this.toggleModal);
    this.modal.addEventListener('click', this.handleBodyClick);
    document.addEventListener('keyup', this.handleKeyUp);

    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.closeModal);
    }
  };

  handleKeyUp = (e) => {
    if (e.key === 'Escape') {
      this.closeModal(e);
    }
  };

  toggleModal = (e) => {
    e.preventDefault();
    this.modal.classList.toggle(this.settings.modalOpen);
    document.body.classList.toggle(this.settings.showOverlay);
  };

  closeModal = (e) => {
    e.preventDefault();
    this.modal.classList.remove(this.settings.modalOpen);
    document.body.classList.remove(this.settings.showOverlay);

    if (this.videoComponent) {
      this.stopVideoOnClose();
    }
  };

  handleBodyClick = (e) => {
    // if the overlay is clicked, close the modal
    if (!this.modalInner.contains(e.target)) {
      this.closeModal(e);
    }
  };

  autoPlayOn = (src) => src.replace('autoplay=0', 'autoplay=1');

  autoPlayOff = (src) => src.replace('autoplay=1', 'autoplay=0');

  stopVideoOnClose = () => {
    const updatedSrc = this.autoPlayOff(this.iframe.getAttribute('src'));
    this.iframe.setAttribute('src', updatedSrc); // stops video playign on close
  };
}

export default (settings) => initialiser(settings, Modal);
